
import { v4 as uuidv4 } from 'uuid';
import {IntegrationActionType} from "../../actions";




const DefaultIntegrationState = {
    onlineShopList:[],
    total:0,
    activeFlagList:[
        {
            id: 1,
            value: 'Y',
            label: `OPEN`
        },
        {
            id: 2,
            value: 'N',
            label: `CLOSE`
        },
        {
            id: 3,
            value: 'C',
            label: `CREATED`
        },
    ],
    ecShopList:[],
    platformList:[],
    owners:[],
    defaultParams:[]

}

export const integrationReducer = ( state = DefaultIntegrationState, action = {}) =>
{
    switch (action.type) {
        case IntegrationActionType.ONLINE_SHOP_SEARCH_LIST:


            return { ...state, onlineShopList: action?.payload?.onlineShopHeaderDtoList?action.payload.onlineShopHeaderDtoList.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total ? action.payload.total:0}
        case IntegrationActionType.ONLINE_SHOP_BASIC_LIST:


            const platformList = action?.payload?.platformCodeList.map((item, index) => {
                return {
                    id: index + 1,
                    value: item,
                    label: item
                };
            });
            return { ...state,ecShopList: action.payload.ecshopDtoList,platformList:[...platformList] }
        case IntegrationActionType.OWNERS_LIST:

            return { ...state,owners:action?.payload?.filter(v=>v.ownerId !== null) }

        case IntegrationActionType.ONLINE_SHOP_DEFAULT_PARAMS:
            return { ...state,defaultParams:action.payload}

        default:
            return state;

    }

}


